var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgText(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 17.5007H7.5",
    stroke: "#3F3F3F",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.99935 2.5V17.5007M9.99935 2.5C11.1555 2.5 12.6406 2.52545 13.823 2.64707C14.3231 2.69849 14.5732 2.72421 14.7944 2.81492C15.2549 3.00357 15.6258 3.41718 15.7655 3.89733C15.8327 4.12817 15.8327 4.39159 15.8327 4.91845M9.99935 2.5C8.84318 2.5 7.35807 2.52545 6.17569 2.64707C5.6756 2.69849 5.42555 2.72421 5.20423 2.81492C4.74388 3.00357 4.37282 3.41718 4.23316 3.89733C4.16602 4.12817 4.16602 4.39159 4.16602 4.91845",
    stroke: "#3F3F3F",
    strokeWidth: 1.25,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgText);
export default __webpack_public_path__ + "static/media/text.a3689a569e84aeda0f245fc6525f8813.svg";
export { ForwardRef as ReactComponent };